import { render, staticRenderFns } from "./confirmacionListaNegra.vue?vue&type=template&id=6352c60e"
import script from "./confirmacionListaNegra.vue?vue&type=script&lang=js"
export * from "./confirmacionListaNegra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports